const ORGANIZATIONS_BASE_ROUTE = '/organizations';

export const ORGANIZATIONS_API_ROUTES = {
  baseRoute: () => ORGANIZATIONS_BASE_ROUTE,
  self: () => `${ORGANIZATIONS_BASE_ROUTE}/self`,
} as const;
